module.exports = __webpack_public_path__ + "static/media/Arial.3508db90.ttf";